import React, { useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import Select from 'react-select'
import { API_URL } from "..";
const AssignAppointmentPage = () => {
  const [data, setData] = useState([]);
  const fetchUser = async () => {
    let headerList = {
      Accept: "*/*",
      "Content-type": "application/json",
    };
      const newLocal = API_URL+`/api/user/fetch-electrician`;
    const response = await fetch(newLocal, {
      method: "GET",
      headers: headerList,
    });
    const dataFor = await response.json();
    if (response.status === 200) {
      const formated = dataFor.data
      .map((e)=>({
        value: e.id,
        label:e.name,
      }))
      setData(formated)
    }
  };
  React.useEffect(() => {
    fetchUser();
  }, [1]);
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Assign Job" />
        <div className="card basic-data-table">
          <div className="card-header">
            <h5 className="card-title mb-0">Assign </h5>
          </div>
          <div className="card-body">
            <div className="row">
                <div className="col-md-4">
                    <Select options={data}/>
                </div>
            </div>
          </div>
        </div>
        {/* TableDataLayer */}
      </MasterLayout>
    </>
  );
};

export default AssignAppointmentPage;
